import {UPDATE_DOCUMENT_UPLOAD_STATE} from "Redux/actions/documentUpload";

const initialState = {
    data: null, isLoaded: false, hasError: false
};

const documentUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DOCUMENT_UPLOAD_STATE:
            return {...state, ...action.newState};
        default:
            return {...state};
    }
};

export default documentUploadReducer;
